import { FormProps, SpaceProps } from 'antd';

const ANTD_DEFAULT_PROPS = {
	FORM: {
		colon: false,
		scrollToFirstError: true,
		requiredMark: (node, { required }) => {
			if (required) {
				return (
					<span style={{ display: 'inline-block' }}>
						{node}
						<span style={{ color: '#E10101' }}>*</span>
					</span>
				);
			}
			return node;
		},
		labelAlign: 'left',
		labelCol: {
			span: 12,
		},
	} as FormProps,
	SPACE: {
		size: 'large',
		style: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'stretch',
		},
	} as SpaceProps,
};

export default ANTD_DEFAULT_PROPS;
